import card1 from "../../pages/htmlcss/cards/card1/card1.png"
import card2 from "../../pages/htmlcss/cards/card2/card2.png"
import card3 from "../../pages/htmlcss/cards/card3/card3.png"
import form1 from "../../pages/htmlcss/forms/form1/form1.png"
import form2 from "../../pages/htmlcss/forms/form2/form2.png"
import footer1 from "../../pages/htmlcss/footers/footer1/footer1.png"
import dropdown from "../../pages/htmlcss/navbars/dropdown/dropdown.jpg"
import mobile from "../../images/htmlcss/mobile.jpg"
import glassdesign from "../../images/htmlcss/glassdesign.jpg"

const items = [
  {
    id: 8,
    title: "Flexbox Mobile App",
    category: "Projects",
    img: mobile,
    desc: `Mobile App designed with HTML5, CSS3, Flexbox and Font Awesome icons`,
    urlLink: "https://igor-htmlcss-flexbox-mobile.netlify.app/",
  },
  {
    id: 9,
    title: "Glass Design",
    category: "Projects",
    img: glassdesign,
    desc: `Website designed with HTML5, CSS3, Flexbox for glass design feel`,
    urlLink: "https://igor-glass-design.netlify.app/",
  },
  {
    id: 1,
    title: "Card 1",
    category: "Cards",
    img: card1,
    desc: `cards elements`,
    urlLink: "/htmlcss/cards/card1/",
  },

  {
    id: 2,
    title: "Card 2",
    category: "Cards",
    img: card2,
    desc: `3 similar cards elements`,
    urlLink: "/htmlcss/cards/card2/",
  },
  {
    id: 3,
    title: "Form 1",
    category: "Forms",
    img: form1,
    desc: `form elements`,
    urlLink: "/htmlcss/forms/form1/",
  },
  {
    id: 4,
    title: "Form 2",
    category: "Forms",
    img: form2,
    desc: `form elements`,
    urlLink: "/htmlcss/forms/form2/",
  },
  {
    id: 5,
    title: "Card 3",
    category: "Cards",
    img: card3,
    desc: `Cards elements pricing`,
    urlLink: "/htmlcss/cards/card3/",
  },
  {
    id: 6,
    title: "Footer",
    category: "Footers",
    img: footer1,
    desc: `Footer element with html and css`,
    urlLink: "/htmlcss/footers/footer1/",
  },
  {
    id: 7,
    title: "Dropdown",
    category: "Navbars",
    img: dropdown,
    desc: `Dropdown Element `,
    urlLink: "/htmlcss/navbars/dropdown/",
  },
]

export default items
